.root {
    position: relative;
    display: inline-flex;
}

.trigger {
    display: inline-flex;
}

.card {
    position: absolute;
    z-index: var(--tempest-z-popover);
    background-color: var(--tempest-bg);
    color: var(--tempest-text);
    border: 1px solid var(--tempest-border);
    border-radius: var(--tempest-radius-lg);
    box-shadow: var(--tempest-shadow-lg);
    padding: var(--tempest-space-3) var(--tempest-space-4);
    min-width: 200px;
    max-width: 320px;
    font-family: var(--tempest-font-sans);
    font-size: var(--tempest-text-base);
    line-height: var(--tempest-leading-snug);
    animation: tempest-hover-card-in var(--tempest-duration-fast) var(--tempest-ease-out);
}

.card:focus {
    outline: none;
}

/* Placements (center-aligned across the trigger). */
.top {
    bottom: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
}
.bottom {
    top: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
}
.left {
    right: calc(100% + 8px);
    top: 50%;
    transform: translateY(-50%);
}
.right {
    left: calc(100% + 8px);
    top: 50%;
    transform: translateY(-50%);
}

@keyframes tempest-hover-card-in {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@media (prefers-reduced-motion: reduce) {
    .card {
        animation: none;
    }
}
